import {
  DataTypeStore,
  formatDataObject,
  LayoutPageType,
  LayoutResponseType,
  LayoutRowType,
  SORT_KEYS,
  WorkflowInstanceTaskType,
} from '@app-store'
import React, { MutableRefObject } from 'react'
import {
  FieldValues,
  UseFormRegister,
  UseFormReturn,
  UseFormSetValue,
} from 'react-hook-form'
import { RowTabIndex, TabIndexMap } from './common'
import { ElementType, EntityLayout, Page, Row } from './layout.types'
import { AgentDataType } from './aws-connect.types'
import { UiDataMappingType } from './correspondenceLogs.types'
import {
  fieldKeyStagingMapping,
  reverseFieldKeyStagingMapping,
} from '../utils/constants'
import { ListingTableRow } from './listingTable.types'
import { AxiosResponse } from 'axios'

export interface DropDownOption {
  value: string
  label: string
  disabled?: boolean
}

export interface IModalState {
  isOpen?: boolean
  isCreate?: boolean | null
}

export interface ConnectedUser extends DataTypeStore {
  Connection_Id: string
  agentId: string
  tenant_id: string
  action: string
  entity: string
}

export interface MultiLookup360WrapperTypes {
  heading: string
  entityId: string
  listViewId: string
  editViewId: string
  relationshipIdentifier: string
  lookupKeyname: string
  parentEditLayoutId: string
  isTab?: boolean
  recordId: string
  entityIdParent: string
  isAssign: boolean
  disableFilters?: boolean
  tabIndexMap?: RowTabIndex
  isViewEntity?: boolean
}

export interface ViewTabTypes {
  layout: LayoutResponseType
  page: LayoutPageType
  layoutList: MutableRefObject<{ [key: string]: LayoutResponseType }>
  recordId: string
  entityId: string
  tabIndexMap?: Record<string, RowTabIndex>
  isPrintLetterView?: boolean
  isWorkflow?: boolean
}

export interface RowRenderTabsTypes {
  row: LayoutRowType
  layout: LayoutResponseType
  data: FieldValues
  editLayout?: LayoutResponseType | null
  index?: number
  entityId?: string
  is360?: boolean
  tabIndexMap?: RowTabIndex
  viewEntityRecordId?: string
  parentLayout?: LayoutResponseType | null
  parentRow?: LayoutRowType | null
  isRootEntityTab?: boolean
}

export interface MultiLookupRenderTabsTypes {
  heading: string
  listingLayout: LayoutResponseType | null
  editLayout: LayoutResponseType | null
  relationIdentifier: string
  lookupKeyname?: string
  entityIdMultilookup?: string
  editIdMultilookup?: string
  layout?: LayoutResponseType | null
  recordId: string
  entityId: string
  tabIndexMap?: RowTabIndex
  isAssign: boolean
  disableFilters?: boolean
  handleAccordionClick?: (accordionExpanded: boolean) => void
  lookupKeynameForGlobal?: string
  isWorkflow?: boolean
  isViewEntity?: boolean
}

export interface NameEntry {
  key: string
  value: string
}

export interface ViewObjectEntry {
  name: NameEntry[]
  recipient?: string
  entity: string
  type: string
  recipient_label?: string
  formatter?: string
}

export interface EntityDataByEntityFilterPayload {
  entity_id: string
  select: string[]
  page: string | number
  size: string | number
  filters: { logical_operator?: string; criteria: formatDataObject[] }[]
  related_entities?:
    | Record<string, { select: string[] }>
    | Record<
        string,
        { select: string[]; filters: { criteria: formatDataObject[] }[] }
      >
  searchQuery?: string
  layout_id: number
  function_parameters?: FieldValues
}

export type ResolveType = (value: boolean) => void

export interface CallHeaderPropsType {
  numberToBeDialed: null
  handleCross: () => void
  contactDetails: connect.AttributeDictionary | null
  isContactClosed: boolean
  getCallTypeText: () => string
  toggleDisplay: () => void
  callDuration: number
}

export interface ShowHyperLinkPropsType {
  element: ElementType
  value: string | undefined | null | string[]
  watchedValue: FieldValues
  onHyperlinkClick: () => void
  tabIndex?: number
  parentKeyVal?: string
}
export interface ShowComputedValuePropsType {
  element: ElementType
  value: string | undefined | null | string[]
  watchedValue: FieldValues
}

export interface IModalState {
  isOpen?: boolean
  isCreate?: boolean | null
}

export interface RenderNestedComponentPropsType {
  row: Row
  data: FieldValues | null | undefined
  fullLayout: EntityLayout
  dataId: string
  mode: 'add' | 'edit' | 'view'
  register: UseFormRegister<FieldValues>
  formUniqueId: string | undefined
  page: Page
  tabIndexmap: TabIndexMap
  addTaskId?: string
  isTaskCompleted?: boolean
  task?: WorkflowInstanceTaskType | null
  parentFormKeyName: string
  methods: UseFormReturn
  reregisterKey: string
  subtotalkeys?: string[]
  handleSubtotalChange?: (key: string, val: FieldValues) => void
}
export interface ShowEditLayoutPropsType {
  lookupVal: FieldValues
  element: ElementType
  setRefetchSelectedId: (value: React.SetStateAction<boolean>) => void
  setRefetchOptions: React.Dispatch<React.SetStateAction<boolean>>
  setIsCreateNew: React.Dispatch<React.SetStateAction<IModalState>>
  refetchSelectedId: boolean
  refetchOptions: boolean
  toggleCreateNew: (isCreate: boolean | null) => void
  editLayout: LayoutResponseType | undefined
  handleSubmit: (values: FieldValues) => Promise<void>
  isCreateNew?: IModalState
}

export interface ShowNoLayoutSectionPropsType {
  setIsCreateNew: React.Dispatch<React.SetStateAction<IModalState>>
  isLoading: boolean
  isCreateNew?: IModalState
}

export interface SubmitButtonEntityLayoutPropsType {
  submitFormButtonRef: React.MutableRefObject<HTMLButtonElement | null>
  draftSubmitFormButtonRef: React.MutableRefObject<HTMLButtonElement | null>
}

export interface RenderNestedEntityLayoutTaskPropsType {
  layout: LayoutResponseType | null
  associatedRecordId: number | undefined
  task: WorkflowInstanceTaskType | null
  tabIndexMap?: TabIndexMap
  tabIndexOffset?: number
  fromInteraction: boolean | undefined
  submitFormButtonRef: React.MutableRefObject<HTMLButtonElement | null>
  draftSubmitFormButtonRef: React.MutableRefObject<HTMLButtonElement | null>
  layoutMode: 'add' | 'edit' | 'view'
  recordData: FieldValues | null
  handleFormSubmit: (
    data: FieldValues,
    originalFormData?: FieldValues
  ) => Promise<void>
  onButtonClick: (() => void) | undefined
  register: UseFormRegister<FieldValues>
  setValue: UseFormSetValue<FieldValues>
  isDisabled?: boolean
  handleInitForm?: (methods: UseFormReturn<FieldValues>) => void
  recordId?: string
  isDraft?: React.MutableRefObject<boolean>
}

export interface MaximizedUIPropsType {
  numberToBeDialed: null
  isCallAccepted: boolean
  isContactClosed: boolean
  quickConnectSearch: string
  setQuickConnectSearch: React.Dispatch<React.SetStateAction<string>>
  transferAgentList: AgentDataType | undefined
  currentContact: connect.Contact | null
  contactDetails: connect.AttributeDictionary | null
  closeContact: () => void
  isMuted: boolean
  setIsMuted: React.Dispatch<React.SetStateAction<boolean>>
  setIsCallAccepted: React.Dispatch<React.SetStateAction<boolean>>
  setIsConfirmModal: React.Dispatch<React.SetStateAction<boolean>>
  toggleDisplay: () => void
  setIsContactClosed: React.Dispatch<React.SetStateAction<boolean>>
  isInboundCall: () => boolean
  callDuration: number
  isHold: boolean
  setIsHold: React.Dispatch<React.SetStateAction<boolean>>
}
export interface NestedAwsConnectPropsType {
  display: boolean
  currentContact: connect.Contact | null
  setDisplay: (value: React.SetStateAction<boolean>) => void
  numberToBeDialed: null
  isCallAccepted: boolean
  isContactClosed: boolean
  quickConnectSearch: string
  setQuickConnectSearch: React.Dispatch<React.SetStateAction<string>>
  transferAgentList: AgentDataType | undefined
  contactDetails: connect.AttributeDictionary | null
  closeContact: () => void
  isMuted: boolean
  setIsMuted: React.Dispatch<React.SetStateAction<boolean>>
  setIsCallAccepted: React.Dispatch<React.SetStateAction<boolean>>
  setIsConfirmModal: React.Dispatch<React.SetStateAction<boolean>>
  callDuration: number
  setIsContactClosed: React.Dispatch<React.SetStateAction<boolean>>
  isHold: boolean
  setIsHold: React.Dispatch<React.SetStateAction<boolean>>
}

export interface CallUIPropsType {
  isContactClosed: boolean
  quickConnectSearch: string
  setQuickConnectSearch: React.Dispatch<React.SetStateAction<string>>
  transferAgentList: AgentDataType | undefined
  currentContact: connect.Contact | null
  contactDetails: connect.AttributeDictionary | null
  closeContact: () => void
  isMuted: boolean
  setIsMuted: React.Dispatch<React.SetStateAction<boolean>>
  setIsContactClosed: React.Dispatch<React.SetStateAction<boolean>>
  getInBoundCallName: () => string
  getInBoundCallNumber: () => string | null
  callDuration: number
  isHold: boolean
  setIsHold: React.Dispatch<React.SetStateAction<boolean>>
}

export interface Field {
  fieldName: string
  incomingValue: string
  existingValue: string
  matched: boolean
}

export interface Group {
  groupName: string
  weight: number
  matched: boolean
  fields: Field[]
}

export interface Props {
  groups: Group[]
}
export interface FilterCriteriaForQueue {
  id?: number
  field_name: string
  operation?: string
  sort_direction?: string
  values?: string[]
  order?: number
  preceding_condition?: string
  direction?: string
}

export interface QueueFilterType {
  id?: number
  field_name: string
  operation: string
  sort_direction?: string | null
  values: unknown[]
  order?: number | null
  preceding_condition?: string | null
}

interface Criteria {
  control: string | null
  field_name: string
  operation: string
  order: string | null
  preceding_condition: string | null
  values: string[]
  timestamp_precision: string
  direction: string | null
}

interface Filter {
  logical_operator: string
  criteria: Criteria[]
}

export interface RelatedEntity {
  time_zone: string | null
  date_format: string | null
  time_format: string | null
  date_time_format: string | null
  root_entity_id: string | null
  root_entity_name: string | null
  entity_id: string | null
  entity_name: string | null
  layout_id: string | null
  relation_identifier: string | null
  embedded: string | null
  path: string | null
  exception_fields: string | null
  controlTypeList: string | null
  searchQuery: string | null
  text_search: string | null
  select: string[]
  filters: Filter[]
  related_entities: Record<string, RelatedEntity>
}

export interface RelatedEntitiesForQueue {
  [key: string]: RelatedEntity
}
export interface Field {
  label: string
  fieldName: string
  incomingValue: string
  existingValue: string
  matched: boolean
}

export interface Group {
  groupName: string
  weight: number
  matched: boolean
  fields: Field[]
}

export interface Props {
  groups: Group[]
}

export interface EligibilityAssessmentDataType {
  id?: string
  enrollment_type?: string
  enrollment_subtype?: string
  enrollment_reason?: string
  decision?: string
  decision_reason?: string
  denial_reason?: string
  request_for_exception?: boolean
  request_for_exception_reason?: string
}

export interface ShipmentDetailsOrderCaseType {
  task: WorkflowInstanceTaskType | null
  mode: 'add' | 'edit' | 'view'
  setValue?: UseFormSetValue<FieldValues>
  register?: UseFormRegister<FieldValues>
  recordId?: string
}

export interface TableColumn {
  accessor: string
  isHidden?: boolean
}

export interface LayoutColumn {
  keyName: string
}

export interface TableHeader {
  label: string
}
export interface LayoutHeader {
  header?: string
  meta?: {
    label: string
  }
}

export type Column = LayoutHeader | TableHeader | TableColumn | LayoutColumn

export interface UiDataMapping {
  alias: string[]
}

export type UiDataMappings = Record<string, UiDataMappingType>

export type DedupeFieldNameType = keyof typeof fieldKeyStagingMapping
export type DedupeEntityNameType = keyof typeof reverseFieldKeyStagingMapping

export type DuplicateResponse = AxiosResponse<{
  content: ListingTableRow[]
  [key: string]: unknown
}>

export interface PotentialMatchTabProps {
  entityName?: 'PATIENT' | 'FACILITY' | 'PROVIDER'
  apiData?: FieldValues
  closePotentialMatchTab?: () => void
  fetchAndSetLookupValue?: (lpId: number | string) => void
}

export interface IntegrationType {
  label: string
  value: string
  identifier: string
  request_type: string
}

export interface IntegrationLogReq {
  request?: Record<string, unknown>
  response?: Record<string, unknown>
  error?: string
}

export interface SortDirectionState {
  keyName: string
  direction: SORT_KEYS
  isAsc: SORT_KEYS
  key: string
}

export interface ExportRelatedEntityConfig {
  select?: string[]
  ui_data_mappings?: Record<string, unknown>
  exclude_fields?: string[]
  filters?: { criteria: formatDataObject[] }[]
  related_entities?: Record<string, ExportRelatedEntityConfig>
}

export interface IntegrationLogsTableProps {
  selectedIntegration?: IntegrationType
  tableName?: string
  defaultPageSize?: number
  isCaseTab?: boolean
}

export interface JsonStructureDetailsProps {
  request: Record<string, unknown>
  response: Record<string, unknown>
  onClose?: () => void
  requestTitle?: string
  responseTitle?: string
  cancelLabel?: string
}

export interface JsonStructureDetailsModalProps
  extends JsonStructureDetailsProps {
  isOpen: boolean
  closeModal: () => void
}

export const ACCESSOR_TO_API_FIELD: Record<string, string> = {
  status: 'status',
  transaction_id: 'request_id',
  request_timestamp: 'created_at',
  response_timestamp: 'modified_at',
  triggered_by: 'created_by',
  entity_id: 'patient_key',
  case_id: 'case_key',
  api: 'identifier',
  status_code: 'http_status',
  product: 'trademarked_name',
  program: 'operational_program_name',
}
export const ACCESSOR_TO_PARENT_ENTITY: Record<string, string> = {
  entity_id: 'patient',
  case_id: 'case',
  api: 'integration_functionality',
  product: 'products',
  program: 'programs',
  request_type: 'integration_functionality',
}
export const ROOT_ENTITY = 'generic_payload'
